<div class='dc-container w-100'>

  <pt-required-reload
    class="display-contents"
    [requiredReload]="showReloadButton"
    (reload)="reload.emit()">
  </pt-required-reload>
  <div
    [ngClass]="{'opacity-25': showReloadButton}"
    *ngIf='charts?.length > 0 && availableStats else noStatsAvailable'>
    <pt-details-title
      [title]='title'
      class='display-contents'>
      <ng-container titleExtra>
<!--        [ngbTooltip]='titleHelp'-->
<!--        placement='top-right'-->
<!--        tooltipClass='pt-tooltip'-->
<!--        triggers='click'-->
        <pt-icon
          *ngIf='titleHelp'
          [iconType]='iconType'
          [key]='iconKey'
          ngbPopover='{{titleHelp}}'
          placement="top"
          popoverClass="pt-popover-custom"
          triggers='mouseenter:mouseleave'>
        </pt-icon>
      </ng-container>
    </pt-details-title>

    <div *ngFor='let chart of currentCharts'
         [style.width]="itemWidth"
         class='dc-chart-container '>
      <div class='dc-chart-card'>
        <div class='dc-chart-col1'>
          <div *ngIf='chart.options'
               [options]='chart.options'
               class='dc-chart-pie'
               echarts>
          </div>
        </div>
        <div [style.color]='defaultColor'
             class='dc-chart-value'>
          {{ chart?.value  | number:'1.0-' + decimal }}
        </div>
        <div class='dc-chart-col2'>
          <div class='dc-chart-description'>
            <div *ngIf='chart.textValue' [style.color]='defaultColor'
                 class='text-value text-ellipsis details-chart-text'
                 ngbPopover='{{(chart.textValue | async) | replaceNullWithText: ND}}'
                 placement="top"
                 popoverClass="pt-popover-custom"
                 triggers='mouseenter:mouseleave'>
              {{ (chart.textValue | async) | replaceNullWithText: ND }}
            </div>

            <div *ngIf='chart.label' class='label text-muted text-ellipsis details-chart-text'
                 ngbPopover='{{(chart.label | async) | replaceNullWithText: ND}}'
                 popoverClass="pt-popover-custom"
                 placement="bottom"
                 triggers='mouseenter:mouseleave'
            >{{ (chart.label | async) | replaceNullWithText: ND }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noStatsAvailable>
    <!--    <ngb-alert [dismissible]="false" class="warning-message mb-3" [type]="'warning'">-->
    <!--      <div class="d-flex align-items-center">-->
    <!--        <pt-icon class="d-flex me-1" [key]='IconWarning' [size]="18"></pt-icon>-->
    <!--        <div class="d-inline-flex">{{'MESSAGE.NO_AVAILABLE_STATS' | translate}}</div>-->
    <!--      </div>-->
    <!--    </ngb-alert>-->
  </ng-template>

</div>

